import type { Account } from "./api";
import { flagHelp, flagsOf, flagText, OFF_SEASON_HELP, STATUS_HELP, STATUS_TEXT } from "./accounts";
import { OUTSIDE_HELP, outsideText } from "./areaMap";
import { earlyPullOf, earlyPullTitle, nextVisitText } from "./calendar";
import { sourceHelp, sourceTagText } from "./dataSource";

export interface RowHint {
  label: string;
  text: string;
}

export const NEXT_VISIT_HELP = "The next visit and the estimated full share at that visit.";

export const earlyPullHelp = (account: Account) =>
  `${earlyPullTitle(
    { ...account.projection, overflow_risk: account.projection?.estimate?.at_visit?.risk },
    account.projection?.early_margin ?? 0.1,
    account.projection?.early_risk,
  )}. The planner suggests an earlier visit.`;

export const statusHelp = (account: Account) => (account.mismatch ? `${STATUS_HELP[account.status]} ${account.mismatch}` : STATUS_HELP[account.status]);

/** The hints of the chips and values of one Accounts row, in the column order, for the keyboard card of the row. */
export function accountHints(account: Account): RowHint[] {
  const hints: RowHint[] = [];
  if (account.projection?.off_season) hints.push({ label: "Off season", text: OFF_SEASON_HELP });
  if (earlyPullOf(account)) hints.push({ label: "Early pull", text: earlyPullHelp(account) });
  for (const flag of flagsOf(account)) hints.push({ label: flagText(account, flag), text: flagHelp(account, flag) });
  if (account.outside_area) hints.push({ label: `Pin in ${account.outside_area.pin_area}`, text: `${outsideText(account.outside_area)} ${OUTSIDE_HELP}` });
  hints.push({ label: STATUS_TEXT[account.status], text: statusHelp(account) });
  if (account.data_source) hints.push({ label: sourceTagText(account.data_source), text: sourceHelp(account.data_source) });
  if (nextVisitText(account) !== "–") hints.push({ label: "Next visit", text: NEXT_VISIT_HELP });
  return hints;
}
